// Utils
import { formatRuleType, LinkCreationService, removeUndefinedPropertiesFromObject } from '@sportal365/smp-widget-utils';
import { IFootballConfig, INormalizedStanding, IStanding, IStandingsConfig } from '../../../../packages/types';
import { TARGET_BLANK, TARGET_SELF } from '../../../../packages/constants/windowTarget';
import { columnsValuesGenerator, extractFootballStandingsValues, TeamFormAndEntityLinks } from '../helpers/standings';

interface INormalizeStandingDataArgs {
  standing?: IStanding;
  dataEntityLinks?: IFootballConfig['dataEntityLinks'];
  dataTeamNameType?: IFootballConfig['dataTeamNameType'];
  dataElements: IStandingsConfig['dataElementsDesktop'] | IStandingsConfig['dataElementsMobile'];
  displayImage: boolean;
  isMobile: boolean;
  dataHighlightEntities?: IStandingsConfig['dataHighlightEntities'];
}

export const normalizeStandingData = ({
  standing,
  dataEntityLinks,
  dataTeamNameType,
  dataElements = [],
  displayImage,
  isMobile,
  dataHighlightEntities,
}: INormalizeStandingDataArgs): INormalizedStanding | undefined => {
  if (!standing) return;
  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const urlTarget = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  const columnValues = extractFootballStandingsValues(standing, isMobile, dataTeamNameType);
  const teamFormRelatedData: TeamFormAndEntityLinks = { dataEntityLinks, teamForm: standing?.team?.form };
  const columnsGenerator = columnsValuesGenerator(dataElements, columnValues, linkService, teamFormRelatedData, urlTarget, displayImage);

  const mobileColumns = columnsGenerator(true);
  const desktopColumns = columnsGenerator(false);

  const highlightedTeams = dataHighlightEntities?.filter((teamId) => teamId !== '' && teamId.toString() === standing.team.id.toString());
  return removeUndefinedPropertiesFromObject({
    isHighlighted: highlightedTeams && highlightedTeams.length > 0,
    ruleType: formatRuleType(standing?.rules?.[0].type),
    mobileColumns,
    desktopColumns,
  });
};
